import {
  AppWindow, BarChart3, Bot, Cpu, Globe, HeartHandshake, Megaphone, MessageCircle, Rocket,
  ShieldCheck, ShoppingBag, Sparkles, Store, Users, Workflow, Zap,
} from "lucide-react";

export const SERVICE_ICONS = {
  Megaphone, Bot, Workflow, AppWindow, ShoppingBag, HeartHandshake, Sparkles, BarChart3,
  MessageCircle, Globe, Rocket, ShieldCheck, Cpu, Store, Users, Zap,
};

export const getIcon = (name) => SERVICE_ICONS[name] || Sparkles;
